import type { Block, Step } from "../api/types";
import { formatDuration, metersToKm } from "../lib/format";
import { PHASE_LABEL } from "../lib/training";
import { t } from "../i18n";

const pace = (s?: number | null) => (s ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}` : "");

function amount(s: Step): string {
  if (s.target === "distance" && s.distance_m) return s.distance_m >= 1000 ? metersToKm(s.distance_m) : `${s.distance_m} m`;
  if (s.target === "time" && s.duration_s) return formatDuration(s.duration_s);
  return t("Livre");
}

function paceText(s: Step): string | null {
  if (s.pace_min_s_km && s.pace_max_s_km) return t("{a} a {b} /km", { a: pace(s.pace_min_s_km), b: pace(s.pace_max_s_km) });
  if (s.pace_min_s_km || s.pace_max_s_km) return `${pace(s.pace_min_s_km || s.pace_max_s_km)} /km`;
  return null;
}

function StepLine({ step }: { step: Step }) {
  const p = paceText(step);
  return (
    <li className={`sv-step phase-${step.phase}`}>
      <span className="sv-phase">{PHASE_LABEL[step.phase]}</span>
      <span className="sv-amount num">{amount(step)}</span>
      {p && <span className="sv-pace num">{p}</span>}
      {step.hr_zone && <span className="sv-zone">{step.hr_zone}</span>}
      {step.note && <span className="sv-note">{step.note}</span>}
    </li>
  );
}

/** Leitura da estrutura em blocos, como o atleta vê. */
export function StructureView({ blocks }: { blocks: Block[] }) {
  if (!blocks.length) return <p className="muted">{t("Sem blocos detalhados.")}</p>;
  return (
    <ol className="structure-view">
      {blocks.map((b, i) =>
        b.kind === "repeat" ? (
          <li key={i} className="sv-repeat">
            <div className="sv-repeat-head">
              <span className="num">{b.times} ×</span>
              {b.skip_last_recovery && <span className="muted">{t("sem recuperação após a última")}</span>}
            </div>
            <ol>
              {b.steps.map((s, k) => (
                <StepLine key={k} step={s} />
              ))}
            </ol>
          </li>
        ) : (
          <StepLine key={i} step={b} />
        ),
      )}
    </ol>
  );
}
